import {
  IGetRequest,
  IPostRequest,
  IPostHeaders,
} from "../Types/NetworkRequest";
import {  AuthContextProps } from "react-oidc-context"; // adjust import if needed

const useNetworkRequest = (auth: AuthContextProps) => {
  const token = auth.user?.id_token; // or access_token if your authorizer expects it

  const baseHeaders: IPostHeaders = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  } as IPostHeaders;

  const makeGetRequest = async <T = unknown>({ endpoint }: IGetRequest): Promise<T> => {
    const getResponse = await fetch(endpoint, {
      method: "GET",
      headers: baseHeaders,
    });

    if (!getResponse.ok) {
      const errorBody = await getResponse.text();
      throw new Error(
        `GET ${endpoint} failed with status ${getResponse.status}: ${getResponse.statusText}\n${errorBody}`
      );
    }

    const data = await getResponse.json();
    return data as T;
  };

  const makePostRequest = async <T = unknown>({
    endpoint,
    customHeaders,
    body,
  }: IPostRequest): Promise<T> => {
    const postResponse = await fetch(endpoint, {
      method: "POST",
      headers: {
        ...baseHeaders,
        ...(customHeaders || {}),
      },
      body,
    });

    if (!postResponse.ok) {
      const errorBody = await postResponse.text();
      throw new Error(
        `POST ${endpoint} failed with status ${postResponse.status}: ${postResponse.statusText}\n${errorBody}`
      );
    }

    const data = await postResponse.json();
    return data as T;
  };

  return {
    makeGetRequest,
    makePostRequest,
  };
};

export default useNetworkRequest;
